import { initialize, addTranslationForLanguage } from 'react-localize-redux';
import store from './store';
import en from './locale/en';
import ru from './locale/ru';
import ka from './locale/ka';
import kaFlag from './assets/images/flags/kaFlag.png'
import ruFlag from './assets/images/flags/ruFlag.png';
import enFlag from './assets/images/flags/enFlag.png';
const locales = [
	{
		flag: enFlag,
		code: 'en',
		name: 'English',
	},
	{
		flag: ruFlag,
		code: 'ru',
		name: 'Russian',
	},
	{
		flag: kaFlag,
		code: 'ka',
		name: 'ქართული',
	},
];

store.dispatch(
	initialize(locales, {
		defaultLanguage: 'ka',
	})
);
store.dispatch(addTranslationForLanguage(en.mainePage, 'en'));
store.dispatch(addTranslationForLanguage(ru.mainePage, 'ru'));
store.dispatch(addTranslationForLanguage(ka.mainePage, 'ka'));



// WEBPACK FOOTER //
// ./src/locale.js